import { APEX_API_URL } from '@/constants';
import { getAxiosInstance } from '@/utils/axios-instance';
import { INextAuthSessionModel } from '@/interfaces/authentication';
import { ICollectableCoupon, ICouponHistory, ICollectableCouponSetting } from '@/interfaces/collectableCoupon';

export const getAvailableCollectableCoupons = async (
  session?: INextAuthSessionModel | null,
): Promise<ICollectableCoupon[]> => {
  let currentSession = session;

  if (!currentSession?.accessToken &&  globalThis.window !== undefined) {
    const { getSession } = await import('next-auth/react');
    const nextAuthSession = await getSession();
    if (nextAuthSession) {
      currentSession = nextAuthSession as INextAuthSessionModel;
    }
  }

  const hasToken = !!currentSession?.accessToken;
  const apiSuffix = hasToken ? 'available' : 'all';

  const headers: Record<string, string> = {};
  if (hasToken) {
    headers['Authorization'] = `Bearer ${currentSession?.accessToken}`;
  }

  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/collectable-coupon/${apiSuffix}`, {
    headers,
  });
  return response.data;
};

export const getCollectableCouponHistory = async (
  session?: INextAuthSessionModel | null,
): Promise<ICouponHistory[]> => {
  let currentSession = session;

  if (!currentSession?.accessToken &&  globalThis.window !== undefined) {
    const { getSession } = await import('next-auth/react');
    const nextAuthSession = await getSession();
    if (nextAuthSession) {
      currentSession = nextAuthSession as INextAuthSessionModel;
    }
  }

  const headers: Record<string, string> = {};
  if (currentSession?.accessToken) {
    headers['Authorization'] = `Bearer ${currentSession?.accessToken}`;
  }

  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/collectable-coupon/history`, {
    headers,
  });
  return response.data;
};

export const getApplicableCoupons = async (
  session?: INextAuthSessionModel | null,
): Promise<ICouponHistory[]> => {
  let currentSession = session;

  if (!currentSession?.accessToken && globalThis.window !== undefined) {
    const { getSession } = await import('next-auth/react');
    const nextAuthSession = await getSession();
    if (nextAuthSession) {
      currentSession = nextAuthSession as INextAuthSessionModel;
    }
  }

  const headers: Record<string, string> = {};
  if (currentSession?.accessToken) {
    headers['Authorization'] = `Bearer ${currentSession?.accessToken}`;
  }

  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/collectable-coupon/applicable`, {
    headers,
  });
  return response.data;
};

export const collectCoupon = async (
  couponId: string | number,
  session?: INextAuthSessionModel | null,
): Promise<boolean> => {
  let currentSession = session;

  if (!currentSession?.accessToken && globalThis.window !== undefined) {
    const { getSession } = await import('next-auth/react');
    const nextAuthSession = await getSession();
    if (nextAuthSession) {
      currentSession = nextAuthSession as INextAuthSessionModel;
    }
  }

  const headers: Record<string, string> = {};
  if (currentSession?.accessToken) {
    headers['Authorization'] = `Bearer ${currentSession?.accessToken}`;
  }

  const response = await getAxiosInstance().post(
    `${APEX_API_URL}/api/collectable-coupon/collect/${couponId}`,
    {},
    {
      headers,
    },
  );
  return response.status === 200 || response.status === 201;
};

export const getDisplayDuration = async (): Promise<ICollectableCouponSetting> => {
  const response = await getAxiosInstance().get(
    `${APEX_API_URL}/api/collectable-coupon/display-duration`,
  );
  return response.data;
};
